<!-- 联系方式 -->
<template>
<div class="contact_lyout">
    <carouselView 
        :bannerList="bannerList" 
        :fileUrl="fileBaseUrl"
        height="2rem" 
        imgHeight="2rem" 
        >
    </carouselView>

    <div class="defalut_content contact_lyout_content">
        <div class="contact_lyout_lookUp">
            <customLookupTitle iconfont="icon-zu405-01" title="联系方式" distance="10px"></customLookupTitle>

            <div class="name_text_one">联系我们</div>
            <div class="name_text_two">CONTACT US</div>
            <div>华略未来科技（重庆）有限公司</div>
            
            <div class="contact_lyout_lookUp_info">
                <div id="container_map" class="contact_lyout_lookUp_info_map"></div>
                <div class="contact_lyout_lookUp_info_content">
                    <div class="title">
                        <!-- <div style="margin-bottom:10px;">
                            华略大数据（重庆）有限公司
                        </div> -->
                        华略未来科技（重庆）有限公司
                    </div>
                    <div class="other">销售中心：重庆市北部新区线外城市花园10栋-9-2室</div>
                    <div class="other">研发中心：重庆市九龙坡区杨家坪环岛渝隆大厦17楼</div>
                    <div class="other">电话：178 2373 5848</div>
                    <div class="other">传真：023-63108446</div>
                    <div class="other">E-Mail：kf@valuetek.com.cn</div>
                    <div class="other">网址：www.valuetek.com.cn</div>
                </div>
                <div class="contact_lyout_lookUp_info_code">
                    <img :src="require('@/assets/images/general/footer_company_code.png')" alt="">
                    <div>公众号</div>
                </div>
            </div>
        </div>

        <div class="contact_lyout_business_consulting">
            <customOptionsTitle title="业务咨询"></customOptionsTitle>

            <div class="contact_lyout_business_consulting_item_kuang">
                <div v-for="(item,index) in businessConsulting" :key="index" class="contact_lyout_business_consulting_item defalut_boder_bottom_line" :class="{contact_lyout_business_consulting_item2:index%2!=0}">
                    <div class="item_befor">
                        <!-- <span class="region">{{item.region}}</span> -->
                        <img class="header" :src="item.header" alt="">
                        <div class="introduce">
                            <div class="name">{{item.name}}</div>
                            <div class="position">{{item.position}}</div>
                        </div>
                        <!-- <span class="phone">{{item.phone}}</span> -->
                    </div>
                    <div class="code">
                        <img :src="item.code" alt="">
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
    import carouselView from 'views/generalView/carouselView.vue'
    import customLookupTitle from 'components/custom-lookup/custom-lookup-title.vue'
    import customOptionsTitle from 'components/custom-options-title/custom-options-title.vue'
    import baseView from "views/base/baseView.vue";
    import {mapGetters, mapMutations, mapActions} from 'vuex'
    import dataConfig from "config/about/contact.data.config.js";
    import {BMPGL} from "./bmpgl.js";
    import metaInfoUtils from 'config/metaInfo.config.js';

    export default {
        extends:baseView,
        metaInfo: metaInfoUtils.currentMetaInfo('/about/contact'),
        components: {
            carouselView,customLookupTitle,customOptionsTitle
        },
        computed: {
            ...mapGetters(['userInfo']),
        },
        data() {
            return {
                bannerList:dataConfig.bannerList,
                businessConsulting:dataConfig.businessConsulting,//业务咨询
            };
        },
        watch:{
           
        },
        created(){
            // this.initMap();
        },
        mounted(){
            BMPGL("EIYDvuk3eiY2dCyHaMCiKu0YXiN2GNm2").then(()=>{
                this.initMap();
            }).catch((error)=>{
                console.log(error);
            });
        },
        methods: {
            initMap(){
                this.$nextTick(() => {
                    let map = new BMapGL.Map("container_map");
                    let point = new BMapGL.Point(106.578315,29.650551);   
                    map.centerAndZoom(point, 18);
                    map.enableScrollWheelZoom(true);//开启鼠标滚轮缩放
                    //缩放级别
                    map.setMinZoom(0);
                    map.setMaxZoom(100);
                    map.addControl(new BMapGL.ScaleControl());// 添加比例尺控件
                    map.addControl(new BMapGL.ZoomControl());// 添加缩放控件控件
                    map.addOverlay(new BMapGL.Marker(point));//创建标注   
                })
            }
        }
    }
</script>

<style lang="less" scoped>
@import url("./contact.less");
</style>
